import 'antd/dist/antd.css';
import * as React from 'react';
import { Form, Button, Affix, Popconfirm } from 'antd';
import * as reactLink from 'react-router-dom';
import { Container, Paper, Card, Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import NoSidebarLayout from '../../layout/nosidebar-layout';
import { SingleProductContext, SingleProductProvider } from '../context/SingleProductContext';
import ProductDetailCard from '../components/Product_detail_card';
import ProductVariationCard from '../components/Product_variation_card';

export default function EditProductView() {
  const { id } = useParams();
  return (
    <NoSidebarLayout>
      <SingleProductProvider>
        <Container maxWidth='lg'>
          <Breadcrumbs separator='>'>
            <Link component={reactLink.Link} to='/products'>
              Main
            </Link>

            <Typography>{id === 'add' ? 'Product Add' : 'Edit Product'}</Typography>
          </Breadcrumbs>
          <ProductForm />
        </Container>
      </SingleProductProvider>
    </NoSidebarLayout>
  );
}

const ProductForm = () => {
  const { submitFormHandler, setId, setForm, errorFormHandler } = React.useContext(SingleProductContext);

  const [bottomCard, setBottomCard] = React.useState({ backgroundColor: 'transparent', boxShadow: 'none' });

  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();

  const onAffixChange = (affixed) => {
    setBottomCard(!affixed ? { backgroundColor: 'transparent', boxShadow: 'none' } : null);
  };

  const cancelFormHandler = () => {
    navigate(-1);
  };

  React.useEffect(() => {
    setId(id);
    setForm(form);
  }, []);

  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
  };

  return (
    <Form
      name='edit_product'
      form={form}
      {...formItemLayout}
      onFinish={submitFormHandler}
      onFinishFailed={errorFormHandler}>
      <Card sx={{ my: 2 }}>
        <ProductDetailCard form={form} />
      </Card>
      <Card sx={{ my: 2 }}>
        <ProductVariationCard form={form} />
      </Card>
      <Affix offsetBottom={0} onChange={onAffixChange}>
        <Paper sx={{ my: 2, pt: 3, pb: 1, ...bottomCard }} elevation={5}>
          <Form.Item
            wrapperCol={{
              span: 5,
              offset: 16,
            }}>
            <Popconfirm
              title='ละทิ้งการแก้ไขทั้งหมด?'
              onConfirm={cancelFormHandler}
              // onCancel={cancel}
              okText='ตกลง'
              cancelText='ยกเลิก'>
              <Button style={{ marginInline: 10 }}>Cancel</Button>
            </Popconfirm>
            <Button style={{ marginInline: 10 }} type='primary' htmlType='submit'>
              Submit
            </Button>
          </Form.Item>
        </Paper>
      </Affix>
    </Form>
  );
};
